// extracted by mini-css-extract-plugin
module.exports = {"loading":"be","fullscreenWrapper":"bf","centeredSpinner":"bh","rotation":"bi","withoutLayer":"bj"};